import React, { useEffect, useState, useRef } from "react";
import Paper from "@material-ui/core/Paper";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import {
  GeneralStyleUM,
  CardsWrapperUM,
  useStylesUM,
} from "./UsersManagementContainer.styled";
import AdminUsersContainer from "../AdminUsersContainer/AdminUsersContainer";
import DownloadUserManagement from "./DownloadUserManagement";
import { useLazyQuery } from "@apollo/client";
import {
  ALL_LOBS_COUNTRY,
  ALL_ROLES_BY_USER_PROFILE,
  COUNTRIES_BY_CLIENT,
} from "../../GraphQL/Queries";
import { NotificationManager } from "react-notifications";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as SiteManagementHeaderIcon } from "../../assets/svg/site-management-header-logo.svg";
import { getUserReports, getDownloadUsersCount } from "../../services/UserReport";

const UsersManagementContainer = () => {
  const [selectedMenu, selectMenu] = useState(["add", "New User"]);
  const classes = useStylesUM();
  const [valueTabs, setValueTabs] = useState(0);
  const [user] = useState(getStateLoginComplete());
  const [showDownloadPage, setShowDownloadPage] = useState(false);
  const rCities = useRef();
  const [allCities, setAllCities] = useState([]);
  const [allRolesByLevel, setRolesByLevel] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [allLobs, setAllLobs] = useState();
  const [clientId] = useState(user.clientId);
  const [selectedCountryIds, setSelectedCountryIds] = useState();
  const [selectedCityIds, setSelectedCityIds] = useState([]);
  const [totalUsersCount, setTotalUsersCount] = useState(null);
  const [loadingAdvanceUsers, setLoadingAdvanceUsers] = useState(false);
  const [selectedLobIds, setSelectedLobIds] = useState([]);
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [usersListRendered, setUsersListRendered] = useState(false);
  const [selectedCheckbox, setSelectedCheckbox] = useState({
    user: true,
    client: true,
    country: true,
    city: true,
    role: true,
    lob: true,
    tpid: true,
    username: true,
    userstatus: true,
  });

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["add", "New User"]);
    if (newValue === 1) selectMenu(["history", "User history"]);
    setValueTabs(newValue);
  };

  const [
    runQueryRolesByLevel,
    { error: errorRoleByLevel, loading: loadingRoleByLevel },
  ] = useLazyQuery(ALL_ROLES_BY_USER_PROFILE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllRolesByLevel = data.rolesByUserProfile.map((element) => {
        return {
          value: element?.roleId,
          label: element?.friendlyDescription,
          roleLevel: element?.roleLevel,
        };
      });
      setRolesByLevel(resultOfAllRolesByLevel);
    },
  });

  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data.countryLocationList.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setAllCountries(resultOfAllCountries);
    },
  });

  const [runQueryLobs] = useLazyQuery(ALL_LOBS_COUNTRY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllLobs = data.lobsListByCountry.map((element) => {
        return {
          value: element?.lobId,
          label: element?.lobName,
        };
      });
      setAllLobs(resultOfAllLobs);
    },
  });

  useEffect(() => {
    if (usersListRendered) {
      if (clientId) {
        runQueryCountry({
          variables: { clientId: clientId },
          context: { clientName: "LinkUsers" },
        });
      }
      if (user.roleId) {
        runQueryRolesByLevel({
          context: { clientName: "LinkUsers" },
        });
      }
    }
  }, [usersListRendered]);

  let handleUsersAdvanceSearch = () => {
    if (!selectedCountryIds) return;
    setLoadingAdvanceUsers(true);
    getDownloadUsersCount({
      countries: selectedCountryIds,
      cities: selectedCityIds,
      roles: selectedRoleIds,
      lobs: selectedLobIds,
      userHeader: selectedCheckbox.user,
      clientHeader: selectedCheckbox.client,
      countryHeader: selectedCheckbox.country,
      cityHeader: selectedCheckbox.city,
      roleHeader: selectedCheckbox.role,
      lobHeader: selectedCheckbox.lob,
      tpIdHeader: selectedCheckbox.tpid,
      userNameHeader: selectedCheckbox.username,
      statusHeader: selectedCheckbox.userstatus,
    })
      .then((result) => {
        const raw = typeof result === 'number' ? result : (result?.totalRows ?? result?.count ?? result?.totalCount ?? result?.data ?? 0);
        const count = Number(raw);
        setTotalUsersCount(Number.isFinite(count) ? count : 0);
      })
      .catch(() => {
        NotificationManager.error("Error retrieving user count.", "", 5000);
      })
      .finally(() => {
        setLoadingAdvanceUsers(false);
      });
  };

  let handleChangeSelectRole = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedRoleIds(selectedItems);
  };

  let handleChangeSelectCountry = (item) => {
    runQueryLobs({
      variables: { countryId: item.value },
      context: { clientName: "LinkUsers" },
    });
    setSelectedCountryIds(item.value);
    let selectedCountry = allCountries.filter(
      (e) => e.countryId === parseInt(item.value)
    );
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setAllCities(citiesArr);
    } else {
      setAllCities([]);
    }
    rCities.current.state.ariaSelection = [];
    rCities.current.clearValue();
    setSelectedCityIds([]);
  };

  let handleChangeSelectCity = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedCityIds(selectedItems);
  };

  let handleChangeSelectLob = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedLobIds(selectedItems);
  };

  let handleDownloadUsers = () => {
    if (
      clientId &&
      selectedCountryIds &&
      selectedCityIds &&
      selectedRoleIds &&
      selectedLobIds &&
      selectedCheckbox
    ) {
      let payload = {
        clientId: clientId,
        countries: selectedCountryIds,
        states: [],
        cities: selectedCityIds,
        roles: selectedRoleIds,
        lobs: selectedLobIds,
        userHeader: selectedCheckbox.user,
        clientHeader: selectedCheckbox.client,
        countryHeader: selectedCheckbox.country,
        cityHeader: selectedCheckbox.city,
        roleHeader: selectedCheckbox.role,
        lobHeader: selectedCheckbox.lob,
        tpIdHeader: selectedCheckbox.tpid,
        userNameHeader: selectedCheckbox.username,
        statusHeader: selectedCheckbox.userstatus,
      };
      getUserReports(payload);
    } else {
      NotificationManager.warning(
        "Please make a selection in the fields and try again.",
        "",
        5000
      );
    }
  };

  const goBack = () => {
    setShowDownloadPage(false);
  };

  return (
    <>
      <GeneralStyleUM>
        <div className={classes.root}>
          <HeaderComponent
            Icon={SiteManagementHeaderIcon}
            text={"Site Management"}
          />
          {showDownloadPage ? (
            <DownloadUserManagement
              allCountries={allCountries}
              handleChangeSelectCountry={handleChangeSelectCountry}
              rCities={rCities}
              allCities={allCities}
              handleChangeSelectCity={handleChangeSelectCity}
              loadingRoleByLevel={loadingRoleByLevel}
              errorRoleByLevel={errorRoleByLevel}
              allRolesByLevel={allRolesByLevel}
              handleChangeSelectRole={handleChangeSelectRole}
              allLobs={allLobs}
              handleChangeSelectLob={handleChangeSelectLob}
              totalUsersCount={totalUsersCount}
              createGroup={handleDownloadUsers}
              labelOfButton={"Export"}
              showCheckboxes={true}
              selectedCheckbox={selectedCheckbox}
              setSelectedCheckbox={setSelectedCheckbox}
              goBack={goBack}
              loadingAdvanceUsers={loadingAdvanceUsers}
              usersListRendered={usersListRendered}
              handleUsersAdvanceSearch={handleUsersAdvanceSearch}
              selectedCountryIds={selectedCountryIds}
              selectedCityIds={selectedCityIds}
              selectedRoleIds={selectedRoleIds}
              selectedLobIds={selectedLobIds}
            />
          ) : (
            <>
              <Paper position="static">
                <AntTabs
                  aria-label="Data Management"
                  value={valueTabs}
                  onChange={handleChange}
                  style={{ overflowX: "auto" }}
                >
                  <AntTab label="Users" id="add" />
                  <AntTab label="Users History" id="history" />
                </AntTabs>
              </Paper>

              <CardsWrapperUM className="pt-3 pb-2"></CardsWrapperUM>

              {(selectedMenu[0] === "add" || selectedMenu[0] === "history") && (
                <AdminUsersContainer
                  selectedMenu={selectedMenu}
                  showDownloadPage={setShowDownloadPage}
                  setUsersListRendered={setUsersListRendered}
                />
              )}
            </>
          )}
        </div>
      </GeneralStyleUM>
    </>
  );
};

export default UsersManagementContainer;
